export default "__VITE_ASSET__BUDERYG5__"